export default __webpack_public_path__ + "static/media/thumb-MDS-3.76f5bc3f.png";